<template>
  <div class="common-home-content space_pl space_pr" v-show="show">
    <div class="patient-info clearfix">
      <span class="fl label">患者信息</span>
      <span class="fr">{{ archive.name }} {{ getSex(archive.sex) }} {{ archive.age }}岁<span
        class="gengd-icon"></span></span>
    </div>
    <div class="patient-self-report">
      <p class="disease">病症自述:</p>
      <p class="disease-summary">{{ archive.description }}</p>
      <div v-if="archive.furred_tongue_img_url || archive.tongue_base_img_url">
        <p class="images-title">舌相照片:</p>
        <ul class="images-ul clearfix">
          <li class="fl">
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              v-if="archive.furred_tongue_img_url"
              alt=""
              :src="archive.furred_tongue_img_url"
              @click="sceneImg(archive.furred_tongue_img_url)"
            />
          </li>
          <li class="fl">
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              v-if="archive.tongue_base_img_url"
              alt=""
              :src="archive.tongue_base_img_url"
              @click="sceneImg(archive.tongue_base_img_url)"
            />
          </li>
        </ul>
      </div>
      <div v-if="archive.diagnose_img_url">
        <p class="images-title">诊断及相关检查:</p>
        <ul class="images-ul clearfix">
          <li class="fl">
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              v-if="archive.diagnose_img_url"
              alt=""
              :src="archive.diagnose_img_url"
              @click="sceneImg(archive.diagnose_img_url)"
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="survey-detail" v-show="answers&&JSON.stringify(answers) != '[]'">
      <p class="title">问诊单详情</p>
      <div v-for="(child, index) in answers.sheet" :key="index">
        <p class="question-title">{{ child.title }}</p>
        <p class="question-answer">{{ child.content }}</p>
      </div>
      <div class="date clearfix">
        <span class="fl">填写时间</span>
        <span class="fr">{{ formatDate(answers.date) }}</span>
      </div>
    </div>
<!--    <div class="prescription-btn" v-if="is_doctor">-->
<!--      <button @click="toPrescription">开方</button>-->
<!--    </div>-->
  </div>
</template>
<script>
import http from '../../util/heraApiConfig'
import {ImagePreview} from "vant"
import {deviceType} from '../../util/deviceType'

export default {
  data() {
    return {
      show: false,
      surveyData: {},
      survey_id: 12,
      user_id: 14,
      archive_id: 1,
      doctor_id: 1,
      token: '',
      answers: {},
      archive: {},
      is_doctor: deviceType.isDoctor,
      platform_type:1,
      isApp: '',
    };
  },
  created() {
    if (this.$route.query.survey_id) {
      this.survey_id = this.$route.query.survey_id;
    }
    if (this.$route.query.user_id) {
      this.user_id = this.$route.query.user_id;
    }
    if (this.$route.query.doctor_id) {
      this.doctor_id = this.$route.query.doctor_id;
    }
    if (this.$route.query.archive_id) {
      this.archive_id = this.$route.query.archive_id;
    }

    let bridge = window.WebViewJavascriptBridge;
    this.isApp = this.$appUtils.isApp();
    if (this.isApp == "IOS") {
      bridge.callHandler("getUserInfo", "", (response) => {
        this.token = response.token;
        this.doctor_id = response.doctor_id;
        this.platform_type = response.platform_type;
      });
    } else if (this.isApp == "android") {
      var user_info = this.$appUtils.appData();
      if (user_info) {
        this.token = user_info.token;
        this.doctor_id = user_info.doctor_id;
        this.platform_type = user_info.platform_type;
      }
    }
    setTimeout(() => {
      this.getDate();
    }, 1000)
    window.appBack = () => this.pageback();
  },
  methods: {
    formatDate(time) {
      return new Date(time * 1000).Format('YYYY年MM月DD日 hh:mm');
    },
    getSex(id) {
      if (id == 0) {
        return '女';
      } else if (id == 1) {
        return '男';
      } else {
        return '';
      }
    },
    getDate() {
      let that = this;
      let params = {
        archive_id: that.archive_id,
        user_id: that.user_id
      }
      http.get("/surveys/answer_last"+"?platform_type="+that.platform_type, {
        params: params,
        headers: {
          "Authorization": that.token
        }
      }).then(function (res) {
        console.log(JSON.stringify(res.data))
        that.archive = res.data.data.archive;
        that.answers = res.data.data.answers;
        that.show = true;
        if(that.isApp != 'IOS'){
          that.$appUtils.appCloseLoadingView();
        }
      });
    },
    sceneImg(images) {
      ImagePreview([images]);
    },
    // toPrescription() {
    //   if(this.isApp == 'IOS'){
    //     let bridge = window.WebViewJavascriptBridge;
    //     let data = {
    //       'user_id': this.user_id,
    //       'name': this.archive.name,
    //       'sex': this.archive.sex,
    //       'age': this.archive.age
    //     }
    //     bridge.callHandler("sendPrescription", data, (response) => {
    //
    //     })
    //   }else if(this.isApp == "android"){
    //     this.$appUtils.appSendPrescription({
    //       'user_id': this.user_id,
    //       'name': this.archive.name,
    //       'sex': this.archive.sex,
    //       'age': this.archive.age
    //     });
    //   }
    // },
    // toArchive() {
    //   this.$appUtils.appOpenArchive({'archive_id': this.archive_id});
    // },
    pageback() {
      window.history.back();
      return;
    }
  },
};
</script>
<style lang="scss" scoped>
.common-home-content {
  padding-bottom: 3px;
}

.patient-info {
  margin-top: 2px;
  width: 100%;
  box-sizing: border-box;
  padding: 15px 26px 15px;
  line-height: 16px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(90deg, #AC4B38 0%, #DB705B 100%);
  box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
  border-radius: 10px;
  position: relative;

  .label {
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: #fff;
  }

  .gengd-icon {
    display: block;
    width: 6px;
    height: 10px;
    background: url('../../assets/images/survey/gengd_white.png') no-repeat;
    background: none \9
  ;
    background-size: 6px 10px;
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 10px;
  }
}

.patient-info-icon {
  display: block;
  width: 6px;
  height: 10px;
  background: url('../../assets/images/survey/gengd.png') no-repeat;
  background: none \9
;
  background-size: 6px 10px;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 15px;
}

.patient-self-report {
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 10px;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
  border-radius: 10px;

  .disease {
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }

  .disease-summary {
    margin-top: 12px;
    margin-bottom: -4px;
    line-height: 20px;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
  }

  .images-title {
    margin-top: 25px;
    line-height: 14px;
    font-size: 14px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }

  .images-ul {
    margin-top: -3px;
    width: 100%;
    box-sizing: border-box;

    & > li {
      width: 80px;
      height: 80px;
      margin-top: 15px;
      margin-right: 15px;
    }

    & > li:last-child {
      margin-right: 0;
    }
  }
}

.survey-detail {
  margin-top: 10px;
  margin-bottom: 7px;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 10px;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
  border-radius: 10px;

  .title {
    margin-bottom: -5px;
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }

  .question-title {
    margin-top: 25px;
    line-height: 14px;
    font-size: 14px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }

  .question-answer {
    margin-top: 12px;
    line-height: 20px;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
  }

  .date {
    margin-top: 25px;
    line-height: 14px;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
}

.prescription-btn {
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 40px;

  button {
    display: block;
    width: 100%;
    line-height: 44px;
    font-size: 17px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    background: rgba(172, 75, 56, 1);
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/consultingdetail.vue